export const SWEEP_STAKE_STATES = {
	CodeInput: "sweepStakeStateCodeInput",
	AddressInput: "sweepStakeStateAddressInput",
	CheckCode: "sweepStakeStateCheckCode",
	ResultNoWin: "sweepStakeStateResultNoWin",
	ResultWin: "sweepStakeStateResultWin",
	ResultError: "sweepStakeStateResultError",
	FatalError: "sweepStakeStateFatalError",
};
